module.exports = __webpack_public_path__ + "img/icon-image.117a6d3e.svg";